/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_EmptyInputs */

const en_tasks_empty = /** @type {(inputs: Tasks_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks yet. Create your first one.`)
};

const pt_br2_tasks_empty = /** @type {(inputs: Tasks_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade ainda. Crie a primeira.`)
};

/**
* | output |
* | --- |
* | "No tasks yet. Create your first one." |
*
* @param {Tasks_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_empty = /** @type {((inputs?: Tasks_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_empty(inputs)
	return pt_br2_tasks_empty(inputs)
});